import styled from 'styled-components';
import HideableBox from '@prisjakt/ui-hideable-box';

/* eslint-disable import/prefer-default-export */
export const Overlay = styled(HideableBox)(props => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: props.theme.bg.overlay,
  zIndex: 99,
}));
